/** The display name built from first and last name, exactly as `Person.display_name` builds it in models/person.py. */
export function nameFromParts(firstName: string | null | undefined, lastName: string | null | undefined): string {
  return `${firstName ?? ''} ${lastName ?? ''}`.trim()
}
